import { render, staticRenderFns } from "./ActiveUrenbonnen.vue?vue&type=template&id=14e94c64"
import script from "./ActiveUrenbonnen.vue?vue&type=script&lang=js"
export * from "./ActiveUrenbonnen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports